export interface RequestAttachmentUploadUrlInput {
    returnOrderId?: string;
    key1Name?: string;
    key1Value?: string;
    key2Name?: string;
    key2Value?: string;
    filename: string;
    type: string;
    visibleToReseller: boolean;
    mimeType: string;
    description?: string;
}

export interface RequestAttachmentUploadUrlOutput {
    id: string;
    url: string;
}

export enum AttachmentType {
    CLAIM_ATTACHMENT_UPLOAD = 'CLAIM_ATTACHMENT_UPLOAD',
    ORDER_LINE_IMAGE_UPLOAD = 'ORDER_LINE_IMAGE_UPLOAD',
    SALES_ORDER_DOCUMENT_UPLOAD = 'SALES_ORDER_DOCUMENT_UPLOAD',
}
